"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = exports.MessageProvider = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MessageContext = _interopRequireDefault(require("./MessageContext"));

var dotterize = function dotterize(str1, str2) {
  if (str1 && str2) {
    return str1 + '.' + str2;
  }

  return str1 || str2 || '';
};

var MessageProvider = function MessageProvider(_ref) {
  var scope = _ref.scope,
      children = _ref.children,
      ignoreGlobalScope = _ref.ignoreGlobalScope;

  var _useContext = (0, _react.useContext)(_MessageContext.default),
      globalScope = _useContext.scope;

  return /*#__PURE__*/_react.default.createElement(_MessageContext.default.Provider, {
    value: {
      scope: ignoreGlobalScope ? scope : dotterize(globalScope, scope)
    }
  }, children);
};

exports.MessageProvider = MessageProvider;
MessageProvider.propTypes = {
  scope: _propTypes.default.string.isRequired,
  ignoreGlobalScope: _propTypes.default.bool,
  children: _propTypes.default.node
};
MessageProvider.defaultProps = {
  ignoreGlobalScope: false
};
MessageProvider.displayName = 'MessageProvider';
var _default = MessageProvider;
exports.default = _default;